import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { OrganisationsService } from '../../services';
import { IOrganisationFilter } from '../../interfaces/organisation-filter';
import { CommsEventService } from '../../services';
import { CommsHistoryService } from '../../services';
import { ICommsHistorySearchItem } from '../../interfaces/comms-history';
import { MergeModelName } from '../../interfaces/comms-template/comms-merge-model';
import { CommsTypeName } from '../../interfaces/comms-template/comms-type';

@Component({
  selector: 'comms-history',
  styleUrls: ['./comms-history.component.scss'],
  templateUrl: 'comms-history.component.html',
})
export class CommsHistoryComponent implements OnInit {
  public commsHistories: ICommsHistorySearchItem[] = [];

  public commsTypeChoices: {}[] = [];
  public filterCommsTypeChoices: {}[] = [];

  public commsEventChoices: {}[] = [];
  public filterCommsEventChoices: {}[] = [];

  public customerChoices: {}[];
  public filterCustomerChoices: {}[] = [];

  public selectedItem: ICommsHistorySearchItem;

  public searchForm: UntypedFormGroup;

  constructor(
    private commsHistoryService: CommsHistoryService,
    private organisationsService: OrganisationsService,
    private formBuilder: UntypedFormBuilder,
    private commsEventService: CommsEventService,
  ) {}
  async ngOnInit() {
    this.fetchCommTypeChoices();
    this.fetchCommEventChoices();
    this.fetchCustomerChoices();
    this.buildForms();
    this.fetchCommsHistory();
  }

  fetchCommsHistory() {
    this.commsHistoryService.getCommsHistory(this.searchForm.value).then((x) => {
      this.commsHistories = x;
      console.log('Comms Histories fetched:', x);
    });
  }

  fetchCommEventChoices() {
    this.commsEventService.getCommsEvents().then((myEvents) => {
      this.commsEventChoices = [];
      this.filterCommsEventChoices = [];

      this.commsEventChoices.push({ value: null, label: 'Select Event Code' });
      this.filterCommsEventChoices.push({ value: null, label: 'All Event Codes' });

      myEvents.forEach((x) => {
        this.commsEventChoices.push({
          value: x.id,
          label: x.commsEventCode + ' (' + MergeModelName[x.mergeModel] + ') : ' + x.title,
        });

        this.filterCommsEventChoices.push({
          value: x.id,
          label: x.commsEventCode,
        });
      });
    });
  }

  fetchCustomerChoices() {
    var organisationFilter: IOrganisationFilter = {
      filters: {
        organisationTypeId: { value: 2 },
      },
    };

    this.organisationsService.getSelectList(organisationFilter).then((x) => {
      this.customerChoices = x.slice(); // Clone the array
      this.filterCustomerChoices = x.slice(); // Clone the array

      this.customerChoices.unshift({ value: null, label: 'Default Template for Customers' });
      this.customerChoices.unshift({ value: -1, label: 'Select Template' });

      this.filterCustomerChoices.unshift({ value: -1, label: 'Default Template' });
      this.filterCustomerChoices.unshift({ value: null, label: 'All Templates' });
    });
  }

  fetchCommTypeChoices() {
    this.commsTypeChoices = [];
    this.filterCommsTypeChoices = [];

    this.commsTypeChoices.push({ value: null, label: 'Select Communication Method' });

    for (const [key, value] of Object.entries(CommsTypeName)) {
      this.commsTypeChoices.push({ value: key, label: value });
    }

    this.filterCommsTypeChoices.push({ value: null, label: 'All Comms Types' });

    for (const [key, value] of Object.entries(CommsTypeName)) {
      this.filterCommsTypeChoices.push({ value: key, label: value });
    }
  }

  buildForms() {
    this.searchForm = this.formBuilder.group({
      commsEventId: [''],
      uniqueId: [''],
      templateName: [''],
      customerId: [''],
      commsType: [''],
      recipientAddress: [''],
    });
  }

  get f() {
    return this.searchForm.value;
  }

  title = 'comms-history';

  asCommsHistorySearchItem(itemUntyped: any): ICommsHistorySearchItem {
    return itemUntyped as ICommsHistorySearchItem;
  }
}
